import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, ArrowRight, Search } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { fetchUniversities } from '../lib/api';

const Universities = () => {
  const [q, setQ] = useState('');
  const [universities, setUniversities] = useState([]);

  useEffect(() => {
    fetchUniversities().then(setUniversities).catch(() => setUniversities([]));
  }, []);

  const list = universities.filter((u) => !q || u.name.toLowerCase().includes(q.toLowerCase()) || (u.location || '').toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Universities in India</h1>
          <p className="text-slate-600 mt-1">Discover top-ranked central, state and private universities.</p>
          <div className="mt-6 relative max-w-2xl">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search universities..." className="w-full pl-11 pr-4 py-3 rounded-full border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none text-sm bg-white" />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {list.map((u) => (
          <Link key={u.id} to={`/universities/${u.slug || u.id}`} className="group bg-white rounded-2xl overflow-hidden border border-slate-200 card-lift">
            <div className="relative h-40 overflow-hidden">
              <img src={u.image} alt={u.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <Badge className="absolute top-3 left-3 bg-white text-slate-900 hover:bg-white">{u.type}</Badge>
              <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-white/95 px-2 py-1 rounded-full text-xs font-semibold">
                <Star className="w-3.5 h-3.5 text-amber-500 fill-amber-500" /> {u.rating}
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-semibold text-slate-900 leading-snug group-hover:text-teal-700 transition-colors" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{u.name}</h3>
              <div className="flex items-center gap-1 text-xs text-slate-500 mt-1"><MapPin className="w-3 h-3" /> {u.location}</div>
              <div className="mt-3 flex items-center justify-between text-xs text-slate-600">
                <span>NAAC: <b className="text-slate-900">{u.naac}</b></span>
                <span>Est. <b className="text-slate-900">{u.established}</b></span>
                <span>{u.courses}+ courses</span>
              </div>
              <div className="mt-3 pt-3 border-t border-slate-100 text-right">
                <span className="text-sm font-semibold text-teal-700 group-hover:text-orange-600 inline-flex items-center gap-1">Explore <ArrowRight className="w-3.5 h-3.5" /></span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Universities;
